module.exports = __webpack_public_path__ + "static/media/view_logs_icon.99602ca2.svg";